import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
  name: 'configs',
  initialState: {
    configs: [],
  },
  reducers: {
    setConfigs: (state, action) => {
      state.configs = action.payload
    },
    addConfig: (state, action) => {
      action.payload && state.configs.push(action.payload)
    },
    deleteConfig: (state, action) => {
      state.configs = state.configs.filter((item) => item.id != action.payload)
    },
  },
})

// Action creators are generated for each case reducer function
export const { setConfigs, addConfig, deleteConfig } = configSlice.actions

export default configSlice.reducer
